import { Navigate, useParams } from 'react-router-dom';
import { useAuftragCtx } from '../pages/AuftragLayout.jsx';
import { useFormularVorlage, useMe } from '../hooks/data.js';
import { Checkliste, Checklisten } from '../pages/Checkliste.jsx';
import { Bewaesserungsplan, Plaene } from '../pages/Bewaesserungsplan.jsx';
import { FormularEditor, FormularListe } from './FormularEditor.jsx';

/** Sonderformulare: eigener Editor im Modul (Vorlage liefert nur Name, Ablage, Datei). */
const SONDER = { bewaesserungsplan: { liste: Plaene, editor: Bewaesserungsplan } };
/** Bisherige Seiten, solange die Firma den neuen Editor nicht eingeschaltet hat (FORMULARE_NEU). */
const BISHER = { uebersichtsliste: { liste: Checklisten, editor: Checkliste } };

function mitVorlage(id, art, kind) {
  return function Seite() {
    const { base } = useAuftragCtx();
    const params = useParams();
    const vorlageId = id ?? params.vorlage;
    const neuerEditor = useMe().data?.optionen?.formulareNeu !== false;
    const alt = !neuerEditor && BISHER[vorlageId];
    const q = useFormularVorlage(alt ? null : vorlageId);
    if (alt) { const Alt = alt[art]; return <Alt />; }
    if (q.isError && !q.data) return <Navigate to={base} replace />;
    if (!q.data) return <div className="narrow"><div className="skeleton" style={{ height: 160 }} /></div>;
    const v = q.data;
    if (v.sonderformular) { const S = SONDER[v.sonderformular][art]; return <S />; }
    return kind(v);
  };
}

function Editor({ vorlage }) {
  const { dateiId } = useParams();
  const { base } = useAuftragCtx();
  if (dateiId !== 'neu' && !/^\d{1,20}$/.test(dateiId ?? '')) return <Navigate to={base} replace />;
  return <FormularEditor key={dateiId} vorlage={vorlage} dateiId={dateiId} />;
}

/** Liste bzw. Editor einer Vorlage; `id` fest (z. B. «uebersichtsliste» unter /checkliste) oder aus der Adresse. */
export const formularListe = (id) => mitVorlage(id, 'liste', (v) => <FormularListe vorlage={v} />);
export const formularEditor = (id) => mitVorlage(id, 'editor', (v) => <Editor vorlage={v} />);
export const FormularListeSeite = formularListe(null);
export const FormularEditorSeite = formularEditor(null);
export const UebersichtslisteListe = formularListe('uebersichtsliste');
export const UebersichtslisteEditor = formularEditor('uebersichtsliste');
